module.exports = __webpack_public_path__ + "img/zozotown.4e6234a2.png";